import { ApiError } from "../../api/client";

export function errorMessage(error: unknown): string {
  if (error instanceof ApiError) {
    return `${error.message}${error.requestId ? ` · 请求 ${error.requestId}` : ""}`;
  }
  if (error instanceof Error) return error.message;
  return "请求失败，请稍后重试。";
}
